var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 14C1 6.82032 6.82032 1 14 1C21.1797 1 27 6.82032 27 14C27 21.1797 21.1797 27 14 27C6.82032 27 1 21.1797 1 14ZM10.1869 11.7671H7.24087V20.619H10.1869V11.7671ZM10.381 9.02896C10.3619 8.16105 9.74125 7.5 8.73338 7.5C7.72555 7.5 7.06667 8.16105 7.06667 9.02896C7.06667 9.87889 7.7061 10.559 8.69513 10.559H8.71398C9.74125 10.559 10.381 9.87889 10.381 9.02896ZM20.8117 15.5436C20.8117 12.8247 19.3583 11.5593 17.4196 11.5593C15.8554 11.5593 15.1551 12.4184 14.7641 13.0212V11.7674H11.8177C11.8565 12.598 11.8177 20.6192 11.8177 20.6192H14.7641V15.6756C14.7641 15.411 14.7833 15.1471 14.8611 14.9578C15.0741 14.4292 15.5589 13.882 16.3728 13.882C17.4393 13.882 17.8656 14.6937 17.8656 15.8832V20.619H20.8116L20.8117 15.5436Z",
    fill: "#2867B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/LinkedIn_icon.d42415b4ed161928a4c281d8b41d3652.svg";
export { ForwardRef as ReactComponent };